class TelPrefix {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-tel-prefix]')
        this.elsSrc = document.querySelectorAll('[data-tel-prefix-dst]')

        if (!this.el) {
            return
        }

        this.el.addEventListener('change', ev => this.update())
        this.update()
    }

    update() {
        const valueEl = this.el.selectedOptions[0]
        if (!valueEl) {
            return
        }
        const value = valueEl.dataset.telPrefixValue
        this.elsSrc.forEach(el => el.innerText = value)
    }
}

export default TelPrefix